import axios from "axios";

const apiUrl = import.meta.env.VITE_API_URL + "tax-rates";

const unwrap = (response) => {
  const data = response.data;
  if (!data.success) throw new Error(data.message || "Request failed");
  return data;
};

export class TaxRateService {
  // Rates, groups, group members, product overrides and the business fallback.
  async getTaxRates() {
    return unwrap(await axios.get(apiUrl, { withCredentials: true }));
  }

  async addTaxRate(rate) {
    return unwrap(await axios.post(apiUrl, rate, { withCredentials: true }));
  }

  async addTaxGroup(group) {
    return unwrap(await axios.post(`${apiUrl}/groups`, group, { withCredentials: true }));
  }

  async updateTax({ id, ...changes }) {
    return unwrap(await axios.put(`${apiUrl}/${id}`, changes, { withCredentials: true }));
  }

  async deleteTax(id) {
    return unwrap(await axios.delete(`${apiUrl}/${id}`, { withCredentials: true }));
  }
}
